import { useState } from "react";
import StyledTable, { ColumnHeader } from "../../../components/table/styled-table";
import NoteTableRow from "./note-table-row";
import { Note } from "../../../service/model/note.model";
import { useAppSelector } from "../../../app/hooks";
import * as noteSlice from "../note.slice";

const headers: ColumnHeader[] = [
    { name: "Content" },
    { name: "Assigned To" },
    { name: "Assignee Type" },
    { name: "Created By" },
    { name: "Created On" },
    { name: "Due Date" },
    { name: "Status" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly notes: Note[];
    readonly onPageChange?: (page: number) => void;
}

const NoteTable: React.FC<TableProps> = ({notes, onPageChange}) => {
    
    const [page, setPage] = useState(1);

    const pageCount = useAppSelector(noteSlice.selectTotalPages);
            
    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
        if (onPageChange) {
            onPageChange(selectedPage);
        }
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={pageCount}
            onPageChange={handlePageChange}>

            {notes?.map(note =>
                <NoteTableRow note={note} key={note.id} />
            )}
        </StyledTable>
    );
}

export default NoteTable;